export default {
  archivesRegisterDeatil: {
    title: "",
    component: () =>
      import(
        "@/mods/warehouse/archivesRegister/detailView/ArchivesRegisterDeatil"
      ),
  },
};
